module.exports = __webpack_public_path__ + "img/vivo_empresa.5d7b78b4.jpg";